
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCommandAutopilot as ObiCommandAutopilotElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-command-autopilot.js';
 
 
 

 
 export const ObiCommandAutopilot = createComponent({
   react: React,
   tagName: 'obi-command-autopilot',
   elementClass: ObiCommandAutopilotElement,
   events: {
     
   }
  });
 
 